import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class BranchService {
  private _currentProgrammeBranchId = null;

  constructor(private http: HttpClient) {}

  get access() {
    return localStorage.getItem('access') === '1';
  }

  set currentProgrammeBranchId(value) {
    this._currentProgrammeBranchId = value;
  }
  get currentProgrammeBranchId() {
    return this._currentProgrammeBranchId;
  }

  getAll() {
    return this.http.get('/branch');
  }
}



// WEBPACK FOOTER //
// G:/UTL/BMI/Admin/Admin-ANG/src/app/services/branch/branch.service.ts